module.exports = __webpack_public_path__ + "img/ja-be-entreprenurial.b02c7ddd.jpg";